var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLensesTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 187 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 187C145.139 187 187 145.139 187 93.5C187 41.8614 145.139 0 93.5 0C41.8614 0 0 41.8614 0 93.5C0 145.139 41.8614 187 93.5 187Z",
    fill: "#73D1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.297 187.493H175L93.7015 10H66.0207V11.3626C74.3169 16.7035 74.9116 24.0933 69.9117 36.5256L2 187.493H20.7596L43.4305 134.323H125.304L148.297 187.493ZM49.1816 120.09L83.7408 39.207L118.831 120.09H49.1816Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2486 89.0631C96.0596 79.7973 94.497 70.4812 91.0925 62.7908C90.9377 62.4428 90.6675 62.2141 90.2938 62.0958C86.6365 60.9346 72.991 70.4706 59.6295 83.0186C45.5755 96.2157 35.8602 108.785 37.1077 111.98C37.1673 112.133 37.2433 112.27 37.3541 112.379C44.4315 119.367 64.1038 119.515 78.6744 108.879",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 113.489C44.5467 110.39 51.8387 106.147 57.8167 101.51C74.3051 88.719 85.0403 74.3811 91.8937 63",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8163 91.4428C81.8501 92.3261 74.1886 94.1247 73.1883 96.3193C73.1164 96.477 73.0672 96.6357 73.0653 96.7981C72.9281 108.137 89.9537 124.23 111.186 124.506C132.42 124.783 144.517 111.771 149.901 98.4661C150.053 98.0925 150.028 97.7255 149.847 97.3669C148.054 93.844 130.857 91.1218 111.588 90.8712C104.774 90.782 98.3704 90.9951 92.8163 91.4428Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0645 98.0625C79.2872 99.5005 87.5871 101.288 95.2356 102.05C116.327 104.152 134.424 101.875 147.596 99.0683",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensesTutorial);
export default __webpack_public_path__ + "static/media/lenses-tutorial.99c84cc9974fbd1627035587aed569a8.svg";
export { ForwardRef as ReactComponent };